const REGISTER_MESSAGES = {
  INVALID_CREDENTIALS: 'Email & Password are required.',
  REGISTER_SUCCESS: 'Resgister successfully',
  REGISTER_FAILURE: 'Oops!!! Something, Somewhere, Shomehow went wrong...',
}

export default REGISTER_MESSAGES
